import { getLocalAuthToken } from './LocalStorageHandler'

export const commonMethods = {
  utcToLocal(dateString) {
    const date = new Date(dateString)

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short'
    }

    return date.toLocaleString('en-US', options)
  },
  utcToLocalTime(dateString) {
    const date = new Date(dateString)

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    }

    return date.toLocaleString('en-US', options)
  },
  utcToLocalOnlyTime(dateString) {
    const date = new Date(dateString)

    const options = {
      hour: 'numeric',
      minute: 'numeric'
    }

    return date.toLocaleString('en-US', options)
  },
  utcToLocalDate(dateString) {
    const date = new Date(dateString)

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }

    return date.toLocaleString('en-US', options)
  },
  utcToLocalShortDate(dateString) {
    const date = new Date(dateString)

    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }

    return date.toLocaleString('en-Gb', options)
  },
  formatDateToISOWithoutTimezone(value) {
    const date = new Date(value)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0')

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:00.000`

    return formattedDate
  },
  handleRetry() {
    window.location.reload()
  },

  getOptionExpiryColor(optionExpiryStatus) {
    if (optionExpiryStatus === 'boldAndRed') return 'bold_and_red'
    if (optionExpiryStatus === 'expired') return 'expired'

    return ''
  },

  getFirstNoticeDayColor(optionExpiryStatus) {
    if (optionExpiryStatus === 'boldAndBlack') return 'bold_and_black'
    if (optionExpiryStatus === 'boldAndRed') return 'bold_and_red'
    if (optionExpiryStatus === 'expired') return 'expired'

    return ''
  },

  parseCustomDateFormat(dateString) {
    const months = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11
    }

    const parts = dateString.match(/(\w+) (\d+), (\d+) at (\d+):(\d+) (\w+)/)

    if (parts) {
      const [, month, day, year, hour, minute, period] = parts

      const monthIndex = months[month]
      let hour24 = parseInt(hour, 10)

      if (period === 'PM' && hour24 < 12) hour24 += 12
      if (period === 'AM' && hour24 === 12) hour24 = 0

      return new Date(year, monthIndex, parseInt(day, 10), hour24, parseInt(minute, 10))
    }

    return new Date(dateString)
  },
  checkForAuthTokenValidity() {
    const currentAuthToken = getLocalAuthToken()

    if (currentAuthToken) {
      const token = currentAuthToken?.split('.')[1]

      const currentTime = Date.now() / 1000

      const base64UrlDecode = () => {
        const response = JSON.parse(atob(token.replace(/-/g, '+').replace(/_/g, '/')))?.exp

        return response
      }

      if (base64UrlDecode() < currentTime) {
        return true
      }

      return false
    }
  },
  numberToWords(num) {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
    const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen']
    const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']

    function twoDigitWords(n) {
      if (n === 0) return ''
      if (n < 10) return ones[n]
      if (n === 10) return 'ten'
      if (n > 10 && n < 20) return teens[n - 11]

      return `${tens[Math.floor(n / 10)]}${n % 10 !== 0 ? `-${ones[n % 10]}` : ''}`
    }

    function threeDigitWords(n) {
      let str = ''

      if (Math.floor(n / 100) > 0) {
        str += `${ones[Math.floor(n / 100)]} hundred `
      }

      str += twoDigitWords(n % 100)

      return str.trim()
    }

    function integerToWords(num) {
      const crore = Math.floor(num / 10000000)
      const lakh = Math.floor((num % 10000000) / 100000)
      const thousand = Math.floor((num % 100000) / 1000)
      const hundred = num % 1000

      let result = ''

      if (crore > 0) {
        result += `${threeDigitWords(crore)} crore `
      }

      if (lakh > 0) {
        result += `${threeDigitWords(lakh)} lakh `
      }

      if (thousand > 0) {
        result += `${threeDigitWords(thousand)} thousand `
      }

      if (hundred > 0) {
        result += threeDigitWords(hundred)
      }

      return result.trim()
    }

    if (Number.isNaN(num)) return ''

    const [integerPart, decimalPartRaw] = num.toFixed(2).split('.')
    const integer = parseInt(integerPart, 10)
    const decimal = parseInt(decimalPartRaw, 10)

    let result = `${integerToWords(integer) || 'zero'}`

    if (decimal > 0) {
      result += ` and ${twoDigitWords(decimal)} paise`
    }

    return `${result.charAt(0).toUpperCase()}${result.slice(1)} only`
  }
}
